import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    browseToChoose: 'or **browse** to choose a file',
  },
  fr: {
    browseToChoose: 'ou **sélectionnez** un fichier',
  },
});
